import { Component, React } from 'react'

class IntroduceGraduate extends Component {
  render() {
    return (
      <div className="felx flex-col text-center mt-40 md:mt-24 -mb-6">
        <h2 className="text-xs text-indigo-500 tracking-widest font-medium title-font mb-1">
          MEMBERS
        </h2>
        <h1 className="sm:text-4xl text-2xl font-medium title-font mb-4 text-gray-900">
          졸업생
        </h1>
      </div>
    )
  }
}
export default IntroduceGraduate;

